import React, { useState, useEffect } from 'react';
import { X, Clock, Crown, AlertTriangle, Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { apiErrorHandler } from '@/helpers/apiErrorHandler';
import { useNavigate } from 'react-router-dom';
import { useDashboard } from '@/contexts/DashboardContext';

export default function TrialExpiryBanner({ isExpired }) {
  const [isDismissed, setIsDismissed] = useState(false);
  const { activeView, setActiveView } = useDashboard();

  // const [isLoading, setIsLoading] = useState(true);


  const handleDismiss = () => {
    sessionStorage.setItem('trial_banner_dismissed', 'true');
    setIsDismissed(true);
  };

  const navigate = useNavigate();

  const handleUpgrade = () => {

    setActiveView("invoices")
    // navigate()

    // TODO: Implement upgrade flow
  };

  // Don't show if loading, dismissed, or not a trial user
  // if (isLoading || isDismissed || !userInfo) return null;
  // if (userInfo.subscription_tier !== 'trial') return null;

  // const daysRemaining = userInfo.trial_days_remaining;
  // const isExpired = userInfo.trial_expired;
  // const isUrgent = daysRemaining !== null && daysRemaining <= 2;

  // Determine banner style based on urgency
  const getBannerStyle = () => {
    if (isExpired) {
      return 'bg-destructive/10 border-destructive/30 text-destructive';
    }
    // return 'bg-primary/10 border-primary/30 text-primary';
  };

  const getIcon = () => {
    if (isExpired) {
      return <AlertTriangle className="h-4 w-4" />;
    }
    // return <Clock className="h-4 w-4" />;
  };

  const getMessage = () => {
    if (isExpired) {
      return 'Your plan has expired. Upgrade now to continue using all features.';
    }
    // if (daysRemaining === 0) {
    //   return 'Your trial expires today! Upgrade now to keep access.';
    // }
    // if (daysRemaining === 1) {
    //   return 'Only 1 day left in your trial. Upgrade to unlock more competitors and features.';
    // }
    // return `${daysRemaining} days left in your trial. Upgrade to unlock more competitors and features.`;
  };

  return (
    <div
      className={`relative flex items-center justify-between px-4 py-2.5 border-b ${getBannerStyle()}`}
      data-testid="trial-expiry-banner"
    >
      <div className="flex items-center gap-3">
        <div className={`p-1.5 rounded-full ${isExpired ? 'bg-destructive/20' : 'bg-primary/20'}`}>
          {getIcon()}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">{getMessage()}</span>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Button
          size="sm"
          onClick={handleUpgrade}
          className={`h-7 px-3 text-xs gap-1.5 ${isExpired
            ? 'bg-destructive hover:bg-destructive/90'
            : ''
            }`}
          data-testid="upgrade-btn"
        >
          <Crown className="h-3 w-3" />
          Upgrade Now
        </Button>

        {!isExpired && (
          <Button
            variant="ghost"
            size="icon"
            onClick={handleDismiss}
            className="h-7 w-7 opacity-60 hover:opacity-100"
            data-testid="dismiss-trial-banner"
          >
            <X className="h-3.5 w-3.5" />
          </Button>
        )}
      </div>
    </div>
  );
}
